import { i18n } from '@/services/i18n';
import ROUTE_NAMES from '@/router/user/ROUTE_NAMES';
import LoginView from '@/views/LoginView.vue';
import LogoutView from '@/views/LogoutView.vue';

export default [
  {
    path: '/login',
    name: ROUTE_NAMES.LOGIN,
    component: LoginView,
    meta: {
      unauthOnly: true,
      title: i18n.t('GENERAL.LOGIN'),
    },
  },
  {
    path: '/logout',
    name: ROUTE_NAMES.LOGOUT,
    component: LogoutView,
  },
];
